import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { Router } from 'react-router';
import store from './redux/store';
import BitkeyPlatformAPI from './utils/bitkey-platform-api';
import { ReduxConnectorComponent } from './redux/ReduxConnector';
import { bkpPath } from './config/baseConfig';

const history = require('history').createBrowserHistory();
BitkeyPlatformAPI.init(bkpPath);

ReactDOM.render(
  <Provider store={store}>
    <ReduxConnectorComponent />
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
